<template>
    <div>
        <b-modal
            v-model="modalShow"
            ref="DoctorReservationCancelModal"
            class="ext-modal ext-modal--lg p-user-reservation"
            :title="`${$locale.consultation_host}を終了`"
            :hide-footer="true"
            @hidden="close">
            <div v-if="consultation">
                <div class="card mb-3">
                    <div class="card-header font-weight-bold">予約内容</div>
                    <div class="card-body">
                        <dl>
                            <dt>予約番号</dt>
                            <dd>
                                <span>#{{ consultation.id }}</span>
                                <span
                                    v-if="Number( consultation.flg_reserved_by_doctor ) === 1"
                                    class="small">
                                    （医師による予約）
                                </span>
                            </dd>
                        </dl>
                        <dl>
                            <dt>{{ $locale.patient }}</dt>
                            <dd>
                                <template v-if="consultation.user">
                                    <span>{{ consultation.user.full_name }}</span>
                                    <span class="small">（{{ consultation.user.full_name_kana }}）</span>
                                </template>
                                <template v-else>
                                    <span class="text-muted">退会済の{{ $locale.patient }}</span>
                                </template>
                            </dd>
                        </dl>

                        <dl>
                            <dt>{{ $locale.consultation_host }}科</dt>
                            <dd>{{ consultation.medical_course.name }}</dd>
                        </dl>

                        <dl>
                            <dt>予約日時</dt>
                            <dd>
                                <span>{{ helper.dateForHuman(consultation.start_time, 'Asia/Tokyo') }}</span>

                                <span
                                    class="small font-weight-bold"
                                    :class="helper.dayForHumanCSS( consultation.start_time, 'Asia/Tokyo' )">
                                    {{ helper.dayForHuman(consultation.start_time, 'Asia/Tokyo', {bracket: true}) }}
                                </span>
                                <span>{{ helper.timeForHuman(consultation.start_time, 'Asia/Tokyo') }}</span>
                                <span>-</span>
                                <span>{{ helper.timeForHuman(consultation.end_time, 'Asia/Tokyo') }}</span>
                            </dd>
                        </dl>
                    </div>
                </div>

                <hr>

                <div class="row">
                    <div class="col">
                        <div class="text-center">
                            <p>上記の{{ $locale.consultation_host }}を終了します。<br>よろしいですか？</p>
                            <div :class="{ 'u-loader u-loader--sm' : inProgress }">
                                <div
                                    v-if="!inProgress"
                                    class="d-flex justify-content-center">
                                    <div class="btn btn-yokumiru-gray mr-2" @click="close">閉じる</div>
                                    <div class="btn btn-yokumiru-doctor" @click="handleOk">{{ $locale.consultation_host }}を終了する</div>
                                </div>
                                <div
                                    v-else
                                    style="width: 100%; height: 37px;">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import moment from 'moment-timezone'
    import constants from '../../../constants'
    import YokumiruHelper from '../../../YokumiruHelper'

    export default {
        data: function () {
            return {
                helper: YokumiruHelper,
                modalShow: false,
                inProgress: false,
                consultation: null,
                statusConfirmed: constants.consultations.confirmed,
                cancel_reason: '',
                errors: {},
            }
        },

        created: function () {
            bus.$on('open-modal-doctor-reservation-finish', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-doctor-reservation-finish')
        },

        methods: {
            /**
             * モーダル表示
             *
             * @param {object} consultation 予約情報
             */
            open: function (consultation) {
                this.consultation = consultation
                this.modalShow = true
                this.errors = {}
            },

            /**
             * モーダル非表示
             */
            close: function () {
                this.modalShow = false
            },

            /**
             * 相談終了ボタン押下時
             */
            handleOk: async function () {
                if (this.inProgress) return
                this.inProgress = true

                const endpoint = `${constants.doctor.consultations.endpoint.base}/${this.consultation.id}/finish`

                await axios.put(endpoint)
                    .then(({data}) => {
                        bus.$emit('alert-success', `${this.$locale.consultation_host}を終了しました。`)
                        bus.$emit('doctor-reservation-finished', data.data)
                        bus.$emit('doctor-agora-should-clear')
                        this.close()
                    })
                    .catch(({response}) => {
                        bus.$emit('alert-danger', 'システムエラーが発生しました。')
                    })

                this.inProgress = false
            },
        },
    }
</script>

<style scoped lang="scss">
    .p-user-reservation {
        .table {
            th, td {
                font-size: .8rem;
            }
        }
    }
</style>

<style lang="scss">
    .fc-toolbar {
        .fc-center {
            h2 {
                font-size: 1.4rem;
                margin-bottom: 0;
            }
        }
    }
</style>
